import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=7bf57c86"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports